import React from 'react'

export function startTime() {
    var together = new Date();
    together.setFullYear(2020, 10, 11); 			//时间年月日，注意月份是0-11
    together.setHours(0);						//小时	
    together.setMinutes(0);						//分钟
    together.setSeconds(0);						//秒前一位
    together.setMilliseconds(0);


    offestTime("2020-10-11 00:00:00");


    var t = '';

    t = setTimeout(function () {
        startTime();
    }, 1000);
}






function offestTime(startDate){
    var time_start = new Date(startDate).getTime();
    var time_now = new Date().getTime();

    var offestTimeHm = time_now-time_start
    
    var allSecond = Math.floor(offestTimeHm/1000)
    
    var res_second = allSecond%(60)

      var off_time =allSecond - res_second

    var off_years =  60*60*24*365
    
var res_year = Math.floor(off_time/off_years)

var off_days = 60*60*24

var yu_years = off_time%off_years


var res_day =Math.floor(yu_years / off_days)



var res_hour =Math.floor((yu_years % off_days) / 60/60)

var res_minute =Math.floor((yu_years % (60*60))/60)


   if(res_second<=9){
    res_second="0"+res_second
   }
 

document.getElementById("sitetime")
&&
(document.getElementById("sitetime").innerHTML = `本站已运行 ${res_year} 年 ${res_day} 天 ${res_hour} 小时 ${res_minute} 分钟 ${res_second} 秒`)

   
   
return{
res_year,res_day,res_hour,res_minute,res_second
}

}




export const runhtml = <div className="site-info">
    <div className="footertext">
        <p style={{ color: "#666666" }}>© {new Date().getFullYear()}</p>
    </div>
    <div className="footer-device">
        <p style={{ fontFamily: 'Ubuntu sans-serif' }}>
            <span style={{ color: "#b9b9b9" }}>
                Theme
<a href="https://github.com/A-ANing" target="_blank" style={{ color: "#b9b9b9", textDecoration: " underline dotted rgba(0, 0, 0, .1)", padding: "0 4px" }}>github</a>
                <img src="/blog.png" className="rotating" style={{  display: "inline-block", }} />
                <a href="https://beian.miit.gov.cn" style={{ color: "#b9b9b9"}}>备案/许可证编号为：渝ICP备20000694号</a>
</span>
            <br /><span id="sitetime">本站已运行 - 年 - 天 - 小时 - 分钟 - 秒</span>
        </p>
    </div>
</div>